import React from "react";
import {Route} from "react-router-dom";

const Builder = React.lazy(() => import("./Builder"));
const Themes = React.lazy(() => import("./Themes"));

const plyInit = {
    reducers: {},
    routes: [
        <Route key="cms_builder" exact path="/cms/builder/:id" element={<Builder />} />,
        <Route key="cms_builder" exact path="/cms/themes" element={<Themes />} />
    ],
    i18n: {
        en: {},
        ar: {
            "Main Template": "القالب الأساسي",
            Homepage: "الصفحة الرئيسية",
        }
    },
};

export default plyInit;

